import { getHost } from '../app';

function logger(data) {
    if (getHost() != 'sofinco_professionnel') {
        console.log(data);
    }
}

export default logger;